import type { Dispatch, LegacyRef, RefObject } from 'react';

import type { Product } from '@/domains/productDiscovery/Recommendation/interfaces/product';

import type { UseRecommendationsFetchState } from '../../hooks/useRecommendations/useRecommendations.interfaces';

export interface IProduct extends Product {
  isInBundle: boolean;
}

export enum EProductBundleActionTypes {
  FILL_LIST = 'productBundle/fillList',
  ADD_PRODUCT = 'productBundle/add',
  REMOVE_PRODUCT = 'productBundle/remove',
  SET_IS_LOADING = 'productBundle/setIsLoading',
}

export interface EProductBundleActions {
  type: EProductBundleActionTypes;
  payload: Array<IProduct> | IProduct['modelId'] | boolean;
}

export interface IProductBundleState {
  ref: RefObject<HTMLElement> | LegacyRef<HTMLElement>;
  state: UseRecommendationsFetchState;
  productList: Array<IProduct>;
  productBundleDispatch: Dispatch<EProductBundleActions>;
  hasProducts: boolean;
  skeletons: number;
  handleAddToCart: () => Promise<void>;
  handleProductCardClick: (id: Product['articleId']) => void;
}
